@if (hasData) {
<div class="opportunity-value-chart">
  <div class="opportunity-value-chart__plot" #plotHost>
    <apx-chart #chart [series]="chartOptions.series!" [chart]="chartOptions.chart!" [colors]="chartOptions.colors!"
      [plotOptions]="chartOptions.plotOptions!" [dataLabels]="chartOptions.dataLabels!"
      [stroke]="chartOptions.stroke!" [xaxis]="chartOptions.xaxis!" [yaxis]="chartOptions.yaxis!"
      [fill]="chartOptions.fill!" [tooltip]="chartOptions.tooltip!" [legend]="chartOptions.legend!"></apx-chart>
  </div>

  <div class="opportunity-value-chart__legend" role="list">
    @for (item of legendItems; track item.key) {
    <button type="button" class="opportunity-value-chart__legend-item" role="listitem"
      [matTooltip]="getLegendItemTooltip(item.key)" (click)="onLegendItemClick(item.key)">
      <span class="opportunity-value-chart__legend-marker" [style.backgroundColor]="item.color"></span>
      <span class="opportunity-value-chart__legend-label">{{ item.labelKey | translate }}</span>
    </button>
    }
  </div>
</div>
} @else {
<app-dashboard-chart-empty-state
  messageKey="dashboard.no_opportunity_value"
  minHeight="10.25rem" />
}
